<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar-container d-flex content align-items-center" },
    [
      _c("ul", { staticClass: "nav navbar-nav d-xl-none" }, [
        _c(
          "li",
          { staticClass: "nav-item" },
          [
            _c(
              "b-link",
              {
                staticClass: "nav-link",
                on: { click: _vm.toggleVerticalMenuActive },
              },
              [_c("feather-icon", { attrs: { icon: "MenuIcon", size: "21" } })],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass:
            "bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex",
        },
        [_c("bookmarks")],
        1
      ),
      _c(
        "b-navbar-nav",
        { staticClass: "nav align-items-center ml-auto" },
        [
          _c("locale"),
          _c("dark-Toggler", { staticClass: "d-none d-lg-block" }),
          _c("search-bar"),
          _c("cart-dropdown"),
          _c("notification-dropdown"),
          _c("user-dropdown"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/components/app-navbar/AppNavbarHorizontalLayout.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import components_Bookmarks_vue from './components/Bookmarks.vue';
import components_Locale_vue from './components/Locale.vue';
import components_DarkToggler_vue from './components/DarkToggler.vue';
import components_SearchBar_vue from './components/SearchBar.vue';
import components_CartDropdown_vue from './components/CartDropdown.vue';
import components_NotificationDropdown_vue from './components/NotificationDropdown.vue';
import components_UserDropdown_vue from './components/UserDropdown.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    // Navbar Components
    BNavbarNav: bootstrapvue["BNavbarNav"],
    Bookmarks: components_Bookmarks_vue,
    Locale: components_Locale_vue,
    DarkToggler: components_DarkToggler_vue,
    SearchBar: components_SearchBar_vue,
    CartDropdown: components_CartDropdown_vue,
    NotificationDropdown: components_NotificationDropdown_vue,
    UserDropdown: components_UserDropdown_vue
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {}
    }
  }
});

//# sourceURL=webpack:///./src/@core/layouts/components/app-navbar/AppNavbarHorizontalLayout.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

